const doc = [({"en":({"js":({"admin":({"tenants":({"create_card":({"the_tenant_was_created":"The tenant was created."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;